import { Classes, HTMLTable } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useProjectModelSettings } from 'src/containers/ProjectSettingsDrawer/hooks/useProjectModelSettingsValue';
import { ProjectSettingsDrawerAiRulesDialog } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawerAiRulesDialog';
import { ProjectSettingsDrawerPrefixTableRow } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawerPrefixTableRow';
import * as copy from 'src/templates/copy';
import { useIsVoiceboxEnabled } from 'src/utils/hooks/useIsVoiceboxEnabled';

export const ProjectSettingsDrawerPrefixTable: React.VFC = () => {
  const isVoiceboxEnabled = useIsVoiceboxEnabled();

  const { sortedModelIds } = useProjectModelSettings();

  const [aiRulesModelId, setAiRulesModelId] = React.useState('');

  return (
    <>
      <HTMLTable
        className={classNames(
          'sd-drawer-project-settings__prefix-table',
          Classes.COMPACT
        )}
        data-testid={TEST_IDS.projectSettingsDrawer.modelNamespaces}
      >
        <thead>
          <tr>
            <th>
              {copy.components.projectSettingsDrawer.prefixTable.dataModel}
            </th>
            <th>
              {copy.components.projectSettingsDrawer.prefixTable.namespace}
            </th>
            <th>
              {copy.components.projectSettingsDrawer.prefixTable.setPrefix}
            </th>
            <th>{copy.components.projectSettingsDrawer.prefixTable.prefix}</th>
            {isVoiceboxEnabled ? (
              <th>
                {copy.components.projectSettingsDrawer.aiHints.columnHeader}
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {sortedModelIds.map((modelId, index) => (
            <ProjectSettingsDrawerPrefixTableRow
              key={modelId}
              index={index}
              modelId={modelId}
              onOpenAiRules={(modelId) => setAiRulesModelId(modelId)}
            />
          ))}
        </tbody>
      </HTMLTable>
      <ProjectSettingsDrawerAiRulesDialog
        aiRulesModelId={aiRulesModelId}
        onClose={() => setAiRulesModelId('')}
      />
    </>
  );
};
